import { RouteItem } from '@eastcoal/router/types/route'

import { SEARCH_RESULT_PAGE_PATH } from './constants/path'

export const searchRoute: RouteItem = {
  title: '全站搜索',
  path: SEARCH_RESULT_PAGE_PATH,
  hideInMenu: true,
  Component: () => import('./index')
}
